
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-choose-home-energy-solutions",
      function () {
        return require("private-next-pages/how-to-choose-home-energy-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-choose-home-energy-solutions"])
      });
    }
  